import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { OAuthService} from 'angular-oauth2-oidc';
import { GS1LoadingService } from '@gs1france/gs1-components-library';

@Component({
    selector: 'login',
    template: ''
})
export class LoginComponent implements OnInit, OnDestroy {

    isAuthorizedSubscription: Subscription;
    isAuthorized: boolean;

    constructor(private router: Router, private oauthService:OAuthService, private loadingService: GS1LoadingService) {

    }
    // async loadInfo() {
    //     if (this.oauthService.hasValidAccessToken()) {
    //         const token = this.oauthService.getAccessToken();
    //     const jwtHelper = new JwtHelperService();
    //     const decodedToken = jwtHelper.decodeToken(token);
    //     console.log(decodedToken);
    //       }
    //    }
    ngOnInit() {
        this.loadingService.startLoading('login');
        if (this.oauthService.hasValidAccessToken()) {
            this.redirect();
        } else {
            this.isAuthorizedSubscription = this.oauthService.events.subscribe(() => {
                if (this.oauthService.hasValidAccessToken()) {
                    this.redirect();
                }
            });
        }
    }

    async redirect() {
        this.loadingService.stopLoading('login');
        this.router.navigate(["/"])
    }

    ngOnDestroy(): void {
        if (this.isAuthorizedSubscription)
            this.isAuthorizedSubscription.unsubscribe();
    }
}
